import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    paddingRight: '12px'
  },
  closeIcon: {
    color: capitalDesignTokens.foundations.colors.gray700
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '0 24px'
  }
});
